import { IOrderLinkRequest } from '../../interfaces';
import { Logger } from '../../../../ui-toolkit/logging/LoggerService';
import { APIFactory } from '../../../../ui-toolkit/rest/APIFactory';
import { baseUrlService } from '../../../../ui-toolkit/rest/BaseUrlService';

export const doCreateOrderLinkAction = async (id: string, orderLinkRequest: IOrderLinkRequest): Promise<void> => {
  try {
    await APIFactory(baseUrlService.ApiLocation).post('orders/v5/admin/order_link', orderLinkRequest);
    return;
  } catch (e: any) {
    Logger.error('Error: create order link', e);
    return Promise.reject(e);
  }
};
